module.exports = __webpack_public_path__ + "static/media/education_s6.416b81ac.svg";